<template>
  <div class="media-page">
    <div class="page-header">
      <img class="header-img" src="@/assets/images/media/header-img.png" />
      <div class="header-title">Multimedia Gallery</div>
    </div>

    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="Photos" name="Photos">
        <Photos></Photos>
      </el-tab-pane>
      <el-tab-pane label="Videos" name="Videos">
        <Videos></Videos>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import Videos from "./components/Videos.vue";
import Photos from "./components/Photos.vue";
export default {
  components: {
    Videos,
    Photos,
  },
  data() {
    return {
      activeName: "Photos",
      constants: {},
      formInline: {},
    };
  },
  mounted() {
    // this.getList();
  },
  methods: {
    handleClick(val) {},
  },
};
</script>
<style scoped lang="scss">
.mobile {
  .media-page {
    padding-top: 50px;
    .page-header {
      position: relative;
      img {
        width: 100%;
        display: block;
      }
      .header-title {
        position: absolute;
        left: fw(205vw, pc);
        bottom: fh(36vh, pc);
        font-size: fh(48vh, pc);
        color: #ffffff;
        line-height: fh(58vh, pc);
      }
    }
    ::v-deep .el-tabs {
      .el-tabs__header {
        padding: 0 10px !important;
      }
      .el-tabs__content {
        //padding: 0 !important;
      }
      .el-tabs__nav-scroll {
        padding: 10px 0 !important;
      }
      .el-tabs__nav-next,
      .el-tabs__nav-prev {
        margin-top: 8px;
      }
    }

    .page-content {
      padding: 0 !important;
    }
  }

  .media-page {
    ::v-deep .el-tabs__content {
      padding: 16px 10px !important;
    }
  }
}
.media-page {
  width: 100%;
  .page-header {
    position: relative;
    img {
      width: 100%;
      display: block;
    }
    .header-title {
      position: absolute;
      left: fw(205vw, pc);
      bottom: fh(36vh, pc);
      font-size: fh(48vh, pc);
      color: #ffffff;
      line-height: fh(58vh, pc);
    }
  }
  ::v-deep .el-tabs {
    width: 100%;
    .el-tabs__content {
      padding: fh(60vh, pc) fw(200vw, pc);
    }
    .el-tabs__header {
      width: 100%;
      left: 0;
      background: #ececec;
      padding: 0 fw(200vw, pc);
      margin-bottom: 0;
    }
    .el-tabs__nav-scroll {
      padding: fh(30vh, pc) 0 !important;
    }
    .el-tabs__item {
      font-size: fh(16vh, pc);
      color: #999999;
      &.is-active {
        color: #333333;
        font-size: fh(18vh, pc);
      }
    }
    .el-tabs__active-bar {
      bottom: fh(-30vh, pc);
      background: #0077d4;
    }
  }
}
</style>
